/* tslint:disable */
/* eslint-disable */
/**
 * MailSlurp API
 * MailSlurp is an API for sending and receiving emails from dynamically allocated email addresses. It\'s designed for developers and QA teams to test applications, process inbound emails, send templated notifications, attachments, and more.  ## Resources  - [Homepage](https://www.mailslurp.com) - Get an [API KEY](https://app.mailslurp.com/sign-up/) - Generated [SDK Clients](https://docs.mailslurp.com/) - [Examples](https://github.com/mailslurp/examples) repository
 *
 * The version of the OpenAPI document: 0.47567.0
 * Contact: contact@mailslurp.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
/**
 *
 */
export class ApiSsoControllerApi extends runtime.BaseAPI {
    /**
     * Find user or create
     */
    async findUserOrCreateIfNoneRaw(requestParameters, initOverrides) {
        if (requestParameters.findUserOrCreateOptions === null || requestParameters.findUserOrCreateOptions === undefined) {
            throw new runtime.RequiredError('findUserOrCreateOptions', 'Required parameter requestParameters.findUserOrCreateOptions was null or undefined when calling findUserOrCreateIfNone.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xSsoSecret !== undefined && requestParameters.xSsoSecret !== null) {
            headerParameters['x-sso-secret'] = String(requestParameters.xSsoSecret);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/sso/find-user-or-create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.findUserOrCreateOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Find user or create
     */
    async findUserOrCreateIfNone(requestParameters, initOverrides) {
        const response = await this.findUserOrCreateIfNoneRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getSamlConfigurationRaw(requestParameters, initOverrides) {
        if (requestParameters.key === null || requestParameters.key === undefined) {
            throw new runtime.RequiredError('key', 'Required parameter requestParameters.key was null or undefined when calling getSamlConfiguration.');
        }
        const queryParameters = {};
        if (requestParameters.slug !== undefined) {
            queryParameters['slug'] = requestParameters.slug;
        }
        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }
        if (requestParameters.key !== undefined) {
            queryParameters['key'] = requestParameters.key;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/sso/saml`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getSamlConfiguration(requestParameters, initOverrides) {
        const response = await this.getSamlConfigurationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getSamlUserOrCreateRaw(requestParameters, initOverrides) {
        if (requestParameters.key === null || requestParameters.key === undefined) {
            throw new runtime.RequiredError('key', 'Required parameter requestParameters.key was null or undefined when calling getSamlUserOrCreate.');
        }
        if (requestParameters.getOrCreateSamlUserOptions === null || requestParameters.getOrCreateSamlUserOptions === undefined) {
            throw new runtime.RequiredError('getOrCreateSamlUserOptions', 'Required parameter requestParameters.getOrCreateSamlUserOptions was null or undefined when calling getSamlUserOrCreate.');
        }
        const queryParameters = {};
        if (requestParameters.key !== undefined) {
            queryParameters['key'] = requestParameters.key;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/sso/saml/user`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.getOrCreateSamlUserOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getSamlUserOrCreate(requestParameters, initOverrides) {
        const response = await this.getSamlUserOrCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Validate link token
     */
    async validateLinkTokenRaw(requestParameters, initOverrides) {
        if (requestParameters.sSOUserLink === null || requestParameters.sSOUserLink === undefined) {
            throw new runtime.RequiredError('sSOUserLink', 'Required parameter requestParameters.sSOUserLink was null or undefined when calling validateLinkToken.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/sso/validate-link`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.sSOUserLink,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Validate link token
     */
    async validateLinkToken(requestParameters, initOverrides) {
        const response = await this.validateLinkTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
